exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timeline-event-historyentry__title{margin-top:15px;font-size:15px;font-weight:700}.timeline-event-historyentry__subtitle{margin-top:15px;font-size:12px;font-weight:500}.timeline-event-historyentry__text{font-size:14px;font-weight:500}.timeline-event-historyentry__text p{margin-bottom:8px}.timeline-event-historyentry__text p:last-child{margin-bottom:0}", ""]);

// exports
